"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";
import { useCasinoPage } from "../CasinoPageContext";
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const ogIcon = new URL("@/app/assets/og-icon.png", import.meta.url).href;

const Footer = () => {
  const { website } = useCasinoPage();

  return (
    <footer className="bg-black py-14 mt-16 border-t border-gray-800/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* GRID SECTIONS */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand section */}
          <div className="text-center md:text-left">
            <div className="flex flex-col md:flex-row md:items-center md:space-x-2 mb-6 items-center">
              <span className="relative h-10 w-10 rounded-full overflow-hidden mb-3 md:mb-0">
                <Image
                  src={ogIcon}
                  alt="CasinoB8 logo"
                  fill
                  sizes="40px"
                  className="object-contain"
                />
              </span>
              <span className="text-2xl font-bold text-white tracking-wide">
                CasinoB8
              </span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-xs mx-auto md:mx-0">
              CasinoB8 connects players with trusted online casino platforms,
              in-depth guides, and responsible gaming resources.
            </p>
            <div className="flex justify-center md:justify-start space-x-5 mt-6">
              <a
                href="#"
                className="hidden text-gray-400 hover:text-yellow-400 transition"
              >
                <FaFacebookF size={18} />
              </a>
              <a
                href="https://www.instagram.com/casino24com/?igsh=MWxodWo2eHpvcHhkZQ%3D%3D"
                target="_blank"
                rel="noopener noreferrer"
                className="text-gray-400 hover:text-yellow-400 transition"
              >
                <FaInstagram size={18} />
              </a>
              <a
                href="#"
                className="hidden text-gray-400 hover:text-yellow-400 transition"
              >
                <FaTwitter size={18} />
              </a>
              <a
                href="#"
                className="hidden text-gray-400 hover:text-yellow-400 transition"
              >
                <FaYoutube size={18} />
              </a>
            </div>
          </div>

          {/* Pages */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold text-lg mb-5">
              CasinoB8 Pages
            </h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>
                <Link href="/" className="hover:text-yellow-400 transition">
                  Home
                </Link>
              </li>
              <li>
                <Link
                  href="/casino-strategies"
                  className="hover:text-yellow-400 transition"
                >
                  Casino Strategies
                </Link>
              </li>
              <li>
                <Link
                  href="/terms-and-conditions"
                  className="hover:text-yellow-400 transition"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  href="/imprint"
                  className="hover:text-yellow-400 transition"
                >
                  Imprint
                </Link>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold text-lg mb-5">
              Quick Links
            </h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li>
                <a
                  href="https://www.casino24.com/casinos"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-yellow-400 transition"
                >
                  Verified Casinos
                </a>
              </li>
              <li>
                <a
                  href="https://www.casino24.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-yellow-400 transition"
                >
                  Exclusive Deals
                </a>
              </li>
              <li>
                <a
                  href="https://www.casino24.com/sports-betting"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-yellow-400 transition"
                >
                  Sports Betting
                </a>
              </li>
              <li>
                <a
                  href="https://www.casino24.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-yellow-400 transition"
                >
                  Casino24
                </a>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div className="text-center md:text-left">
            <h4 className="text-white font-semibold text-lg mb-5">
              Support &amp; Safety
            </h4>
            <p className="text-gray-400 text-sm mb-2">
              Email: <span className="font-mono">support@casinob8.com</span>
            </p>
            <p className="text-gray-400 text-sm mb-2">24/7 online resources</p>
            <p className="text-gray-400 text-sm">
              18+ | Play responsibly. Gambling involves financial risk. Only
              play with money you can afford to lose.
            </p>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-gray-800 pt-8 text-center space-y-2">
          <p className="text-gray-500 text-xs sm:text-sm">
            © {new Date().getFullYear()} CasinoB8. All rights reserved.
          </p>
          <p className="text-gray-500 text-xs sm:text-sm leading-relaxed max-w-xl mx-auto">
            CasinoB8 is an affiliate information site – we do not offer real
            money gambling. Always check local laws and play responsibly.
          </p>

          {/* Powered by Hypegrow */}
          <p className="text-gray-400 text-xs sm:text-sm mt-2">
            Powered by{" "}
            <a
              href="https://www.hypegrow.net"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 font-medium transition-colors"
            >
              Hypegrow
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
